import { collection, query, orderBy, getDocs, addDoc, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebaseconfig';

export const fetchPosts = async (userArea, sortBy, sortOrder) => {
  try {
    const postsCollectionRef = collection(db, userArea);
    const q = query(postsCollectionRef, orderBy(sortBy, sortOrder));
    const querySnapshot = await getDocs(q);
    
    const allPosts = [];
    querySnapshot.forEach((doc) =>
      allPosts.push({
        id: doc.id,
        ...doc.data(),
        area: userArea,  // El área es siempre la misma que la del usuario
      })
    );
    
    return allPosts;
  } catch (error) {
    console.error('Error al obtener los posts:', error);
    return [];
  }
};

export const addOrUpdatePost = async (userArea, formData, postId = null, area = null) => {
  try {
    // Si el área no es pasada, usamos la del usuario
    const areaToUse = area || userArea;
    const postsCollectionRef = collection(db, areaToUse);
    
    if (postId) {
      // Si tenemos un postId, realizamos la actualización
      const postRef = doc(db, areaToUse, postId);
      await updateDoc(postRef, { ...formData, costo: parseFloat(formData.costo) });
      return { id: postId, ...formData, costo: parseFloat(formData.costo), area: areaToUse };
    } else {
      // Si no tenemos postId, creamos un nuevo documento
      const docRef = await addDoc(postsCollectionRef, { ...formData, costo: parseFloat(formData.costo) });
      return { id: docRef.id, ...formData, costo: parseFloat(formData.costo), area: areaToUse };
    }
  } catch (error) {
    console.error('Error al guardar el post:', error);
    throw error;
  }
};

export const deletePost = async (area, postId) => {
  try {
    const postRef = doc(db, area, postId);
    await deleteDoc(postRef);
  } catch (error) {
    console.error('Error al eliminar el post:', error);
    throw error;
  }
};
